module.exports = __webpack_public_path__ + "static/media/tanque-gris.fbd15dab.svg";